import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgConfidence40 = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M4.79484 6.2644C3.31388 7.95155 2.41602 10.1632 2.41602 12.5845",
			stroke: "var(--success-icon-color, #00AD11)",
			strokeWidth: 1.5,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.55664 14.2285C3.02204 16.921 4.6108 19.2287 6.82276 20.6514",
			stroke: "var(--success-icon-color, #00AD11)",
			strokeWidth: 1.5,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.5918 21.0001C19.1057 19.6257 20.9361 17.1576 21.4434 14.2356",
			stroke: "var(--progress-track-bg, #CEDBDD)",
			strokeWidth: 1.5,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.5858 12.5846C21.5858 10.2617 20.7595 8.13186 19.3848 6.4729",
			stroke: "var(--progress-track-bg, #CEDBDD)",
			strokeWidth: 1.5,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.4125 5.46017C16.7142 3.93081 14.4662 3 12.0008 3C9.67411 3 7.54101 3.82908 5.88086 5.20794",
			stroke: "var(--progress-track-bg, #CEDBDD)",
			strokeWidth: 1.5,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.16 16V14.88H6.25V14.01L9.4 9.13H10.5V13.71H11.42V14.88H10.5L10.5 16H9.16ZM7.73 13.78H9.26V11.32L7.73 13.78ZM15.5552 16.08C14.7552 16.08 14.1085 15.77 13.6152 15.15C13.1285 14.5233 12.8852 13.6633 12.8852 12.57C12.8852 11.51 13.1252 10.66 13.6052 10.02C14.0852 9.37333 14.7352 9.05 15.5552 9.05C16.3685 9.05 17.0185 9.36333 17.5052 9.99C17.9918 10.6167 18.2352 11.4767 18.2352 12.57C18.2352 13.63 17.9952 14.48 17.5152 15.12C17.0352 15.76 16.3818 16.08 15.5552 16.08ZM14.6152 14.22C14.8485 14.62 15.1652 14.82 15.5652 14.82C15.9652 14.82 16.2785 14.6267 16.5052 14.24C16.7318 13.8467 16.8452 13.29 16.8452 12.57C16.8452 11.87 16.7318 11.32 16.5052 10.92C16.2785 10.52 15.9652 10.32 15.5652 10.32C15.1652 10.32 14.8485 10.5167 14.6152 10.91C14.3885 11.2967 14.2752 11.85 14.2752 12.57C14.2752 13.2633 14.3885 13.8133 14.6152 14.22Z",
			fill: "var(--label-color, #475B5E)"
		})
	]
});
export default SvgConfidence40;
